import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatSelectModule} from '@angular/material/select';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatChipsModule} from '@angular/material/chips';
import {MatSidenavModule} from '@angular/material/sidenav';
import {LayoutComponent} from './components/layout/layout.component';
import {CommonItemsListComponent} from './components/items/items.component';
import {
    PreviewImageDialogComponent
} from '@emm/common-items/dialogs/preview-image-dialog/preview-image-dialog.component';
import {SelectionPanelComponent} from './components/selection-panel/selection-panel.component';
import {ItemDataService} from './services/item-data.service';
import {CommonItemsRoutingModule} from './common-items-routing.module';
import {MatTooltip} from '@angular/material/tooltip';
import {CommonItemComponent} from '@emm/common-items/components/common-item/common-item.component';
import {CommonItemDetailsComponent} from '@emm/common-items/components/common-item-details/common-item-details.component';
import {FindAttributePipe} from '@emm/shared/pipes/find-attribute.pipe';
import {MatTableModule} from '@angular/material/table';
import {
    CommonItemsFaqDialogComponent
} from '@emm/common-items/dialogs/common-items-faq-dialog/common-items-faq-dialog.component';
import {HelpButtonComponent} from '@emm/common-items/components/help-button/help-button.component';
import {FilterKeyPipe} from '@emm/shared/pipes/filter-key.pipe';
import {QuickViewButtonComponent} from '@emm/common-items/components/quick-view-button/quick-view-button.component';
import {VariationsDialogComponent} from '@emm/common-items/dialogs/variations-dialog/variations-dialog.component';
import {
    AddComponentDialogComponent
} from '@emm/common-items/dialogs/add-component-dialog/add-component-dialog.component';
import {
    CreateOrEditAssignmentDialogComponent
} from '@emm/common-items/dialogs/create-or-edit-assignment-dialog/create-or-edit-assignment-dialog.component';
import {
    CreateVariationDialogComponent
} from '@emm/common-items/dialogs/create-variation-dialog/create-variation-dialog.component';
import {
    EditVariationMetadataDialogComponent
} from '@emm/common-items/dialogs/edit-variation-metadata-dialog/edit-variation-metadata-dialog.component';
import {
    CreateCommonItemDialogComponent
} from '@emm/common-items/dialogs/create-common-item-dialog/create-common-item-dialog.component';
import {FlexModule} from '@angular/flex-layout';
import {MockDataService} from './services/mock-data.service';
import {MatAutocomplete, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {ClassTypeChipsComponent} from '@emm/common-items/components/class-type-chips/class-type-chips.component';
import {ComponentsCardComponent} from '@emm/common-items/components/components-card/components-card.component';
import {OverridesCardComponent} from '@emm/common-items/components/overrides-card/overrides-card.component';
import {AssignmentsCardComponent} from '@emm/common-items/components/assignments-card/assignments-card.component';

@NgModule({
    declarations: [
        LayoutComponent,
        CommonItemsListComponent,
        CommonItemDetailsComponent,
        PreviewImageDialogComponent,
        SelectionPanelComponent,
        CommonItemComponent,
        FindAttributePipe,
        FilterKeyPipe,
        CommonItemsFaqDialogComponent,
        HelpButtonComponent,
        QuickViewButtonComponent,
        VariationsDialogComponent,
        AddComponentDialogComponent,
        CreateOrEditAssignmentDialogComponent,
        CreateVariationDialogComponent,
        EditVariationMetadataDialogComponent,
        CreateCommonItemDialogComponent,
        ClassTypeChipsComponent,
        ComponentsCardComponent,
        OverridesCardComponent,
        AssignmentsCardComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatSelectModule,
        MatToolbarModule,
        MatTabsModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatChipsModule,
        MatSidenavModule,
        CommonItemsRoutingModule,
        MatTooltip,
        MatTableModule,
        FlexModule,
        MatAutocomplete,
        MatAutocompleteTrigger,
    ],
    providers: [
        ItemDataService,
        MockDataService,
    ],
    exports: [
        LayoutComponent,
        CommonItemsListComponent,
        CommonItemDetailsComponent,
        SelectionPanelComponent,
        CommonItemComponent,
        CommonItemsFaqDialogComponent,
        HelpButtonComponent,
        QuickViewButtonComponent,
        VariationsDialogComponent,
        AddComponentDialogComponent,
        CreateOrEditAssignmentDialogComponent,
        CreateVariationDialogComponent,
        CreateCommonItemDialogComponent,
        ClassTypeChipsComponent,
        ComponentsCardComponent,
        OverridesCardComponent,
        AssignmentsCardComponent,
    ]
})
export class CommonItemsModule {
}
